/*
 Created by qing 2020/2/18 7:56 下午
 */

import {
  FORM_ITEM__SINGLE_LINE,
  FORM_ITEM__MULTILINE,
  FORM_ITEM__NUMBER,
  FORM_ITEM__CURRENCY,
  FORM_ITEM__SERIAL_NUMBER,
  FORM_ITEM__DESCRIPTION,
  FORM_ITEM__SINGLE_CHOOSE,
  FORM_ITEM__CHECKBOX,
  FORM_ITEM__DROPDOWN,
  FORM_ITEM__RTF,
  FORM_ITEM__DATE,
  FORM_ITEM__DATE_RANGE,
  FORM_ITEM__IMAGE,
  FORM_ITEM__ATTACHMENT,
  FORM_ITEM__GRADE,
  FORM_ITEM__IMAGE_CHOOSE,
  FORM_ITEM__SLIDING_BLOCK,
  FORM_ITEM__YES_NO,
  FORM_ITEM__ADDRESS,
  FORM_ITEM__MEMBER,
  FORM_ITEM__DEPARTMENT,
  FORM_ITEM__TABLE,
  FORM_ITEM__SUMMARY,
  FORM_ITEM__EXTERNAL_DATA_SOURCE,
  FORM_ITEM__PHONE,
  FORM_ITEM__LOCATION,
  FORM_ITEM__OUT_REQUEST, FORM_ITEM__FORM_RUN_STATUS, FORM_ITEM__FLOW_DETAIL_INFO,
  FORM_ITEM__CASCADE
} from '../../../RyForm/types'

import FilterAddress from "./FilterAddress"
import FilterCheckbox from "./FilterCheckbox"
import FilterString from "./FilterString"
import FilterNumber from "./FilterNumber"
import FilterDate from "./FilterDate"
import FilterGrade from "./FilterGrade"
import FilterSlidingBlock from "./FilterSlidingBlock"
import FilterYesNo from "./FilterYesNo"
import FilterSingleChoose from "./FilterSingleChoose"
import FilterMember from "./FilterMember"
import FilterDep from "./FilterDep"
import FilterDropdown from "./FilterDropdown"

export default {
  ['filter_' + FORM_ITEM__ADDRESS]: FilterAddress,
  ['filter_' + FORM_ITEM__CHECKBOX]: FilterCheckbox,
  ['filter_' + FORM_ITEM__IMAGE_CHOOSE]: FilterCheckbox,
  ['filter_' + FORM_ITEM__SINGLE_LINE]: FilterString,
  ['filter_' + FORM_ITEM__MULTILINE]: FilterString,
  ['filter_' + FORM_ITEM__SERIAL_NUMBER]: FilterString,
  ['filter_' + FORM_ITEM__FORM_RUN_STATUS]: FilterString,
  ['filter_' + FORM_ITEM__FLOW_DETAIL_INFO]: FilterString,
  ['filter_' + FORM_ITEM__NUMBER]: FilterNumber,
  ['filter_' + FORM_ITEM__CURRENCY]: FilterNumber,
  ['filter_' + FORM_ITEM__SUMMARY]: FilterNumber,
  ['filter_' + FORM_ITEM__PHONE]: FilterString,
  ['filter_' + FORM_ITEM__DATE]: FilterDate,
  ['filter_' + FORM_ITEM__GRADE]: FilterNumber,
  ['filter_' + FORM_ITEM__SLIDING_BLOCK]: FilterNumber,
  ['filter_' + FORM_ITEM__YES_NO]: FilterYesNo,
  ['filter_' + FORM_ITEM__SINGLE_CHOOSE]: FilterSingleChoose,
  ['filter_' + FORM_ITEM__MEMBER]: FilterMember,
  ['filter_' + FORM_ITEM__DEPARTMENT]: FilterDep,
  ['filter_' + FORM_ITEM__DROPDOWN]: FilterDropdown,
  ['filter_' + FORM_ITEM__EXTERNAL_DATA_SOURCE]: FilterString,
  ['filter_' + FORM_ITEM__OUT_REQUEST]: FilterString,
  ['filter_' + FORM_ITEM__CASCADE]: FilterString,
}
